/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { useMotion } from '../entering/use-motion';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { UseMotionProps, UseMotionResult, CustomMotionXCSS } from '../entering/use-motion';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { Reanimate } from '../entering/reanimate';
